/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImportContractResultDto } from '../models/ImportContractResultDto';
import type { ImportNewCustomerResultDto } from '../models/ImportNewCustomerResultDto';
import type { ImportServiceObjectResultDto } from '../models/ImportServiceObjectResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ImportTemplatesService {
  /**
   * Download new customer CSV template
   * Returns a CSV template with headers, type hints, required indicators, and example data for bulk customer import. Use this template to import Customer Groups, Customers, Points of Sale, and Areas.
   * @returns binary CSV file with 4 header rows (columns, types, required flags, example)
   * @throws ApiError
   */
  public static importTemplatesControllerV1DownloadNewCustomerTemplateV1(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/import-templates/new-customer',
    });
  }
  /**
   * Download contract CSV template
   * Returns a CSV template for creating contracts with existing customers, areas, and partners. Requires customers, areas, partners, and contract types to already exist in the system.
   * @returns binary CSV file with 4 header rows (columns, types, required flags, example)
   * @throws ApiError
   */
  public static importTemplatesControllerV1DownloadContractTemplateV1(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/import-templates/contract',
    });
  }
  /**
   * Download service objects CSV template
   * Returns a CSV template for importing service objects (equipment, machinery) linked to areas and customers. Requires existing Customers, Areas, and ServiceObjectTypes in the system. Optionally create new partners or link to existing partners.
   * @returns binary CSV file with 4 header rows (columns, types, required flags, example)
   * @throws ApiError
   */
  public static importTemplatesControllerV1DownloadServiceObjectTemplateV1(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/import-templates/service-objects',
    });
  }
  /**
   * Upload filled new customer CSV
   * Process a CSV file to bulk create customers, customer groups, points of sale, and areas. All operations are performed in a single transaction (all-or-nothing). If any row fails validation or processing, the entire import is rolled back.
   * @param formData
   * @returns ImportNewCustomerResultDto create entity
   * @throws ApiError
   */
  public static importTemplatesControllerV1UploadNewCustomerTemplateV1(formData: {
    /**
     * CSV file matching the new customer template structure
     */
    file?: Blob;
  }): CancelablePromise<ImportNewCustomerResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/import-templates/new-customer/upload',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Upload filled contract CSV
   * Process a CSV file to create contracts with points of sale for existing customers. All operations are performed in a single transaction (all-or-nothing). Customers, Contract Types, Areas, and Partners must already exist in the database.
   * @param formData
   * @returns ImportContractResultDto create entity
   * @throws ApiError
   */
  public static importTemplatesControllerV1UploadContractTemplateV1(formData: {
    /**
     * CSV file matching the contract template structure
     */
    file?: Blob;
  }): CancelablePromise<ImportContractResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/import-templates/contract/upload',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Upload filled service objects CSV
   * Process a CSV file to bulk create service objects linked to areas. All operations are performed in a single transaction (all-or-nothing). Areas, Locations, and ServiceObjectTypes must already exist in the database.
   * @param formData
   * @returns ImportServiceObjectResultDto create entity
   * @throws ApiError
   */
  public static importTemplatesControllerV1UploadServiceObjectTemplateV1(formData: {
    /**
     * CSV file matching the service objects template structure
     */
    file?: Blob;
  }): CancelablePromise<ImportServiceObjectResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/import-templates/service-objects/upload',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
